import React from "react";

const ConfirmModal = ({
  open,
  onClose,
  onConfirm,
  loading = false,
  titleKey,
  descriptionKey,
  confirmTextKey = "Delete",
  cancelTextKey = "Cancel",
  icon,
}) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[999] flex items-center justify-center p-4 animate-fade-in">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/40 backdrop-blur-sm" />

      {/* Modal */}
      <div className="relative bg-white w-full max-w-md rounded-[32px] shadow-2xl overflow-hidden animate-scale-up">

        {/* Content */}
        <div className="p-8 text-center">
          <div className="w-20 h-20 bg-red-50 rounded-full flex items-center justify-center mx-auto mb-6">
            {icon}
          </div>

          <h3 className="text-2xl font-black text-brand-dark mb-2">
            {titleKey}
          </h3>

          <p className="text-gray-500 font-medium px-4">
            {descriptionKey}
          </p>
        </div>

        {/* Footer */}
        <div className="p-6 bg-gray-50 flex gap-4">
          <button
            onClick={onClose}
            className="flex-1 px-6 py-3 rounded-2xl font-bold text-gray-500 border-2 border-gray-200 hover:bg-white transition-all"
          >
            {cancelTextKey}
          </button>

          <button
            onClick={onConfirm}
            disabled={loading}
            className="flex-1 bg-red-500 text-white px-6 py-3 rounded-2xl font-bold flex items-center justify-center gap-2 disabled:opacity-70"
          >
            {loading && (
              <span className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" />
            )}

            {loading ? "Processing..." : confirmTextKey}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;